import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Grid } from "../../../node_modules/@material-ui/core";
import Card from "../../../node_modules/@material-ui/core/Card";
import CardActions from "../../../node_modules/@material-ui/core/CardActions";
import CardContent from "../../../node_modules/@material-ui/core/CardContent";
import CardMedia from "../../../node_modules/@material-ui/core/CardMedia";
import Button from "../../../node_modules/@material-ui/core/Button";

import MenuHome from "./includes/MenuHome";
import GridItemPic1 from "../assets/images/home-grid-item-1.png";
import GridItemPic2 from "../assets/images/home-grid-item-2.png";
import GridItemPic3 from "../assets/images/home-grid-item-3.png";

import "../assets/css/Home.css";

const lang = "";

const decodeURLParams = search => {
  const hashes = search.slice(search.indexOf("?") + 1).split("&");
  return hashes.reduce((params, hash) => {
    const split = hash.indexOf("=");
    const key = hash.slice(0, split);
    const val = hash.slice(split + 1);
    return Object.assign(params, { [key]: decodeURIComponent(val) });
  }, {});
};

class Home extends Component {
  constructor(props) {
    super(props);
    //console.log('constructor');
    //console.log(props);
    this.lang = props.lang ? props.lang : "";
    //console.log('constructor, this.lang:', this.lang);
  }

  componentDidMount() {
    //console.log(this.props);
    if (this.props.location.search !== null) {
      let urlParams = decodeURLParams(this.props.location.search);
      //console.log(urlParams);
      if (urlParams.p) {
        this.props.history.push(urlParams.p);
      }
    }
    document.title = this.getLangText({
      tc: "FxHB Group",
      sc: "FxHB Group",
      en: "FxHB Group"
    });
    //console.log("componentDidMount(), ", this.lang);
  }

  getLangText(langJson) {
    //console.log("getLangText(), this.lang:", lang);
    return this.lang ? langJson[this.lang] : langJson["tc"];
  }

  getLink(page) {
    return this.lang ? "/" + this.lang + "/" + page : "/" + page;
  }

  render() {
    return HomeJSX(this);
  }
}

const HomeJSX = ctx => (
  <div className={ctx.lang === "en" ? "en" : ""}>
    <MenuHome lang={ctx.lang} />

    <div className="main-content-container home">
      <div className="main-content-inner-wrapper">
        <Grid container spacing={0}>
          <Grid
            item
            style={{
              height: "32pt",
              lineHeight: "32pt",
              fontSize: "24pt",
              borderLeft: "solid 5pt rgb(245,120,42)",
              paddingLeft: "10px",
              marginBottom: "30px"
            }}
          >
            <span style={{ color: "#606060", fontWeight: "normal" }}>
              {ctx.getLangText({
                tc: "我們的業務",
                sc: "我们的业务",
                en: "Our Business"
              })}
            </span>
          </Grid>
        </Grid>

        <Grid className="home-silder-container" container spacing={32}>
          <Grid container item xs={12} sm={6} md={4} lg={4}>
            <Card className="material-card">
              <Link to={ctx.getLink("forex")}>
                <CardMedia
                  className="card-media"
                  image={GridItemPic2}
                  title="信息技术方案咨询"
                  style={{ height: "240px" }}
                />
              </Link>
              <CardContent className="material-CardContent">
                <h2 style={{ fontWeight: "normal", fontSize: "26px" }}>
                  {ctx.getLangText({
                    tc: "信息技術方案咨詢",
                    sc: "信息技术方案咨询",
                    en: "Information Technology Solutions Consulting"
                  })}
                </h2>
                <p>
                  {ctx.getLangText({
                    tc:
                      "基於統一門戶、統一用戶、統一安全、統一應用、統一數據的系統技術架構體系，構建基於PC、移動等多形式的運營應用。",
                    sc:
                      "基于统一门户、统一用户、统一安全、统一应用、统一数据的系统技术架构体系，构建基于PC、移动等多形式的运营应用。",
                    en: `Based on the technology architecture system of unified portal, unified user, unified security, unified application, and unified data, we build operation applications in various formats for PC and mobile.`
                  })}
                </p>
              </CardContent>
              <CardActions className="material-CardActions-sticky-bottom">
                <Button>
                  <Link
                    to={ctx.getLink("forex")}
                    style={{
                      textDecoration: "none",
                      color: "rgb(245, 120, 42)"
                    }}
                  >
                    <span style={{ fontSize: "16px", textTransform: "none" }}>
                      {ctx.getLangText({
                        tc: "了解更多>",
                        sc: "了解更多>",
                        en: "More>"
                      })}
                    </span>
                  </Link>
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid container item xs={12} sm={6} md={4} lg={4}>
            <Card className="material-card">
              <Link to={ctx.getLink("asset-management")}>
                <CardMedia
                  className="card-media"
                  image={GridItemPic3}
                  title="運營外包咨詢"
                  style={{ height: "240px" }}
                />
              </Link>
              <CardContent className="material-CardContent">
                <h2 style={{ fontWeight: "normal", fontSize: "26px" }}>
                  {ctx.getLangText({
                    tc: "運營外包咨詢",
                    sc: "运营外包咨询",
                    en: "Operations Outsourcing Consulting"
                  })}
                </h2>
                <p>
                  {ctx.getLangText({
                    tc: `從位於企業運營最前端的客戶聯絡中心，到企業內部經營運作的後台支持業務，提供多類別、個性化、一站式的外包解決方案。`,
                    sc: `从位于企业运营最前端的客户联络中心，到企业内部经营运作的后台支持业务，提供多类别、个性化、一站式的外包解决方案。`,
                    en:
                      "From customer service, which is at the forefront of the company's operations, to the company's back-office support, we provide multi-category, personalized, and one-stop outsourcing solutions for our clients."
                  })}
                </p>
              </CardContent>
              <CardActions className="material-CardActions-sticky-bottom">
                <Button>
                  <Link
                    to={ctx.getLink("asset-management")}
                    style={{
                      textDecoration: "none",
                      color: "rgb(245, 120, 42)"
                    }}
                  >
                    <span style={{ fontSize: "16px", textTransform: "none" }}>
                      {ctx.getLangText({
                        tc: "了解更多>",
                        sc: "了解更多>",
                        en: "More>"
                      })}
                    </span>
                  </Link>
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/pages/Home.js